import { ICounterProps } from "./Counter.props";
import cn from "classnames";
import styles from "./Counter.module.scss";

export default function Counter({
  children,
  count,
  className,
  ...props
}: ICounterProps) {
  return (
    <div className={cn(styles.wrapper, className)} data-row={count}>
      {children}
    </div>
  );
}
